export enum LocalStorageKey {
    SearchCriteria = 'noc_search_cri',
    DataLayerOfferOriginPrefix = 'dl_offer_origin_',
    DataLayerSearchResults = 'dl_search_results',
}
